/**
 * @generated SignedSource<<6f594b7dbb87c2344672dbd81a3f7c9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ElementTypeV2 = "clozeText" | "file" | "multipleChoice" | "order" | "podcast" | "randomMultipleChoice" | "text" | "video" | "%future added value";
export type searchNodesCarouselComponent_Refetch$variables = {
  after?: string | null;
  elementTypes?: ReadonlyArray<ElementTypeV2> | null;
  first?: number | null;
  query?: string | null;
  tagIds?: ReadonlyArray<string> | null;
};
export type searchNodesCarouselComponent_Refetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"searchNodesCarouselComponent_NodeFragment">;
};
export type searchNodesCarouselComponent_Refetch = {
  response: searchNodesCarouselComponent_Refetch$data;
  variables: searchNodesCarouselComponent_Refetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "elementTypes"
  },
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tagIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "elementTypes",
    "variableName": "elementTypes"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  },
  {
    "kind": "Variable",
    "name": "tagIds",
    "variableName": "tagIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortDescription",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "restartTriesCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "InfectopharmTreeConfigConsequences",
  "kind": "LinkedField",
  "name": "configConsequences",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasActiveContentSubmission",
  "storageKey": null
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentSubmissionInfo",
  "kind": "LinkedField",
  "name": "heftContentSubmissionInfo",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfSubmittedAnswers",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentSubmissionInfo",
  "kind": "LinkedField",
  "name": "multipleChoiceContentSubmissionInfo",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstLearnOpportunityIdWithMultipleChoiceElement",
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reasonConfigTypes",
    "storageKey": null
  }
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "viewerTreeState",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v13/*: any*/),
      "type": "CanNotBeStartedViewerTreeState",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headContentId",
          "storageKey": null
        }
      ],
      "type": "IsStartedViewerTreeState",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v17 = [
  (v16/*: any*/),
  (v2/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cmePoints",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitionType",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "containedElementTypes",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "configType",
  "storageKey": null
},
v23 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isRestartIfFailedContentConfigResult"
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canBeRestarted",
  "storageKey": null
},
v25 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "blockedUntil",
    "storageKey": null
  }
],
v26 = {
  "kind": "InlineFragment",
  "selections": (v25/*: any*/),
  "type": "NegativeBlockTemporarilyWhenRewardedRestartIfFailedContentConfigResult",
  "abstractKey": null
},
v27 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "CanNotBeStartedContentNodeAdvancementResult",
  "abstractKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeContentSubmissionId",
      "storageKey": null
    }
  ],
  "type": "ContinueContentNodeAdvancementResult",
  "abstractKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "extension",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amountOfMultipleChoiceElementsInContentSubmission",
          "storageKey": null
        },
        (v18/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headFirstElementType",
          "storageKey": null
        }
      ],
      "type": "LearnContentExtensionImpl",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "extension",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v6/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/)
      ],
      "type": "LearnOpportunityRootExtensionImpl",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "searchNodesCarouselComponent_Refetch",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "searchNodesCarouselComponent_NodeFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "searchNodesCarouselComponent_Refetch",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LearnV2Queries",
        "kind": "LinkedField",
        "name": "LearnV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "LearnOpportunitiesV2Connection",
            "kind": "LinkedField",
            "name": "NodesSearchResult",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LearnOpportunitiesV2Edge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LearnOpportunityV2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LearnOpportunityV2",
                        "kind": "LinkedField",
                        "name": "root",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "extension",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v6/*: any*/),
                                          (v9/*: any*/),
                                          (v10/*: any*/),
                                          (v11/*: any*/),
                                          (v12/*: any*/)
                                        ],
                                        "type": "LearnOpportunityRootExtensionImpl",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v14/*: any*/)
                                ],
                                "type": "LearnOpportunityRootStructureDefinition",
                                "abstractKey": null
                              },
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "attachmentsV2",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "File",
                                    "kind": "LinkedField",
                                    "name": "file",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "InfectopharmFileAttachment",
                                "abstractKey": null
                              },
                              (v2/*: any*/),
                              (v15/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "description",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "typeDefinition",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LearnOpportunityV2",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": true,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "attachmentsV2",
                                        "plural": true,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "File",
                                                "kind": "LinkedField",
                                                "name": "file",
                                                "plural": false,
                                                "selections": (v17/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "InfectopharmFileAttachment",
                                            "abstractKey": null
                                          },
                                          (v2/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "LearnOpportunityBranchTypeDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "structureDefinition",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v15/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "extension",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "internalCode",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "dateTimeOnlyAdminsVisibility",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isVisibleOnlyForAdmins",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "IssuedCertificateV2",
                                        "kind": "LinkedField",
                                        "name": "issuedCertificates",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "issuedAt",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "File",
                                            "kind": "LinkedField",
                                            "name": "fileRef",
                                            "plural": false,
                                            "selections": (v17/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ReducedDataInTree",
                                        "kind": "LinkedField",
                                        "name": "reducedDataInTree",
                                        "plural": false,
                                        "selections": [
                                          (v18/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "elementTypes",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "firstReleasedAt",
                                        "storageKey": null
                                      },
                                      (v12/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "firstContentNodeIdWithoutMultipleChoiceElement",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentSubmissionInfo",
                                        "kind": "LinkedField",
                                        "name": "heftContentSubmissionInfo",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "activeContentSubmissionStartedAt",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentSubmissionInfo",
                                        "kind": "LinkedField",
                                        "name": "multipleChoiceContentSubmissionInfo",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "passedContentSubmissionFinishedAt",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "InfectopharmTreeConfigConsequences",
                                        "kind": "LinkedField",
                                        "name": "configConsequences",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "rewardExpired",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isRewardedTo",
                                            "storageKey": null
                                          },
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "lengthInSecondsOverride",
                                        "storageKey": null
                                      },
                                      (v10/*: any*/)
                                    ],
                                    "type": "LearnOpportunityRootExtensionImpl",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LearnOpportunityRootStructureDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v19/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "contentNodeAdvancementResult",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "configResults",
                                        "plural": true,
                                        "selections": [
                                          (v4/*: any*/),
                                          (v22/*: any*/),
                                          (v23/*: any*/),
                                          (v24/*: any*/),
                                          (v26/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "CanNotBeRestartedAfterFailedContentNodeAdvancementResult",
                                    "abstractKey": null
                                  },
                                  (v27/*: any*/),
                                  (v28/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v29/*: any*/)
                            ],
                            "type": "LearnOpportunityELearningContentTypeDefinition",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LearnOpportunityV2",
                                "kind": "LinkedField",
                                "name": "children",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "typeDefinition",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v19/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v20/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "contentNodeAdvancementResult",
                                            "plural": false,
                                            "selections": [
                                              (v4/*: any*/),
                                              (v21/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "configResults",
                                                    "plural": true,
                                                    "selections": [
                                                      (v4/*: any*/),
                                                      (v22/*: any*/),
                                                      (v23/*: any*/),
                                                      (v24/*: any*/),
                                                      (v26/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": (v25/*: any*/),
                                                        "type": "NegativeBlockTemporarilyRestartIfFailedContentConfigResult",
                                                        "abstractKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "CanNotBeRestartedAfterFailedContentNodeAdvancementResult",
                                                "abstractKey": null
                                              },
                                              (v27/*: any*/),
                                              (v28/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v29/*: any*/)
                                        ],
                                        "type": "LearnOpportunityELearningContentTypeDefinition",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LearnOpportunityV2",
                                    "kind": "LinkedField",
                                    "name": "root",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "structureDefinition",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v30/*: any*/),
                                              (v14/*: any*/)
                                            ],
                                            "type": "LearnOpportunityRootStructureDefinition",
                                            "abstractKey": null
                                          },
                                          (v15/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "structureDefinition",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v30/*: any*/)
                                        ],
                                        "type": "LearnOpportunityRootStructureDefinition",
                                        "abstractKey": null
                                      },
                                      (v15/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LearnOpportunityBranchTypeDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "filters": [
              "query",
              "tagIds",
              "elementTypes"
            ],
            "handle": "connection",
            "key": "searchNodesCarouselComponent_NodesSearchResult",
            "kind": "LinkedHandle",
            "name": "NodesSearchResult"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "40a3b853916dd5bdf41fa024ef3bf64c",
    "id": null,
    "metadata": {},
    "name": "searchNodesCarouselComponent_Refetch",
    "operationKind": "query",
    "text": "query searchNodesCarouselComponent_Refetch(\n  $after: String\n  $elementTypes: [ElementTypeV2!]\n  $first: Int = 10\n  $query: String\n  $tagIds: [ID!]\n) {\n  ...searchNodesCarouselComponent_NodeFragment_Kg7Dy\n}\n\nfragment ContentNodesButtons_NodeFragment on LearnOpportunityV2 {\n  id\n  root {\n    id\n  }\n  shortDescription\n  structureDefinition {\n    __typename\n    title\n  }\n  ...ProjectContentButtonCME_LearnOpportunityFragment\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      containedElementTypes\n    }\n    ... on LearnOpportunityBranchTypeDefinition {\n      children {\n        ...ProjectContentButtonCME_LearnOpportunityFragment\n        id\n        shortDescription\n        structureDefinition {\n          __typename\n          title\n        }\n        typeDefinition {\n          __typename\n          definitionType\n          ... on LearnOpportunityELearningContentTypeDefinition {\n            containedElementTypes\n            contentNodeAdvancementResult {\n              __typename\n              status\n              ... on CanNotBeStartedContentNodeAdvancementResult {\n                reasonConfigTypes\n              }\n              ... on ContinueContentNodeAdvancementResult {\n                activeContentSubmissionId\n              }\n              ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n                configResults {\n                  __typename\n                  configType\n                  __isRestartIfFailedContentConfigResult: __typename\n                  canBeRestarted\n                  ... on NegativeBlockPermanentlyRestartIfFailedContentConfigResult {\n                    canBeRestarted\n                  }\n                  ... on NegativeBlockTemporarilyRestartIfFailedContentConfigResult {\n                    blockedUntil\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  shortDescription\n  root {\n    id\n    structureDefinition {\n      __typename\n      title\n      ... on LearnOpportunityRootStructureDefinition {\n        viewerTreeState {\n          __typename\n          kind\n          ... on CanNotBeStartedViewerTreeState {\n            reasonConfigTypes\n          }\n          ... on IsStartedViewerTreeState {\n            headContentId\n          }\n        }\n      }\n    }\n  }\n  structureDefinition {\n    __typename\n    title\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      contentNodeAdvancementResult {\n        __typename\n        status\n      }\n      containedElementTypes\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          cmePoints\n          headFirstElementType\n        }\n      }\n    }\n  }\n}\n\nfragment NodeCardBadgeComponent_Fragment on LearnOpportunityV2 {\n  structureDefinition {\n    __typename\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on LearnOpportunityRootExtensionImpl {\n          reducedDataInTree {\n            cmePoints\n          }\n          configConsequences {\n            rewardExpired\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NodeCardCertificateButton_Fragment on LearnOpportunityV2 {\n  structureDefinition {\n    __typename\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on LearnOpportunityRootExtensionImpl {\n          issuedCertificates {\n            fileRef {\n              url\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NodeCardDateComponent_Fragment on LearnOpportunityV2 {\n  structureDefinition {\n    __typename\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on LearnOpportunityRootExtensionImpl {\n          configConsequences {\n            isRewardedTo\n            rewardExpired\n          }\n          reducedDataInTree {\n            cmePoints\n          }\n          firstLearnOpportunityIdWithMultipleChoiceElement\n          multipleChoiceContentSubmissionInfo {\n            passedContentSubmissionFinishedAt\n          }\n          heftContentSubmissionInfo {\n            hasActiveContentSubmission\n            activeContentSubmissionStartedAt\n          }\n          firstReleasedAt\n          issuedCertificates {\n            issuedAt\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NodeCardDurationAndAwardComponent_Fragment on LearnOpportunityV2 {\n  structureDefinition {\n    __typename\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on LearnOpportunityRootExtensionImpl {\n          lengthInSecondsOverride\n          reducedDataInTree {\n            cmePoints\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NodeCardFooterContainer_LearnOpportunityFragment on LearnOpportunityV2 {\n  id\n  structureDefinition {\n    __typename\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on LearnOpportunityRootExtensionImpl {\n          firstLearnOpportunityIdWithMultipleChoiceElement\n          heftContentSubmissionInfo {\n            hasActiveContentSubmission\n          }\n        }\n      }\n    }\n  }\n  ...NodeCardLearnProgressComponent_Fragment\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      containedElementTypes\n    }\n    ... on LearnOpportunityBranchTypeDefinition {\n      children {\n        ...NodeCardLearnProgressComponent_Fragment\n        id\n        typeDefinition {\n          __typename\n          ... on LearnOpportunityELearningContentTypeDefinition {\n            containedElementTypes\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NodeCardLearnProgressComponent_Fragment on LearnOpportunityV2 {\n  root {\n    structureDefinition {\n      __typename\n      ... on LearnOpportunityRootStructureDefinition {\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            configConsequences {\n              restartTriesCount\n            }\n            heftContentSubmissionInfo {\n              hasActiveContentSubmission\n            }\n            numberOfSubmittedAnswers\n            multipleChoiceContentSubmissionInfo {\n              hasActiveContentSubmission\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  structureDefinition {\n    __typename\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on LearnOpportunityRootExtensionImpl {\n          configConsequences {\n            restartTriesCount\n          }\n          heftContentSubmissionInfo {\n            hasActiveContentSubmission\n          }\n          numberOfSubmittedAnswers\n          multipleChoiceContentSubmissionInfo {\n            hasActiveContentSubmission\n          }\n        }\n      }\n    }\n  }\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          amountOfMultipleChoiceElementsInContentSubmission\n        }\n      }\n      contentNodeAdvancementResult {\n        __typename\n        status\n        ... on CanNotBeStartedContentNodeAdvancementResult {\n          reasonConfigTypes\n        }\n        ... on ContinueContentNodeAdvancementResult {\n          activeContentSubmissionId\n        }\n        ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n          configResults {\n            __typename\n            configType\n            __isRestartIfFailedContentConfigResult: __typename\n            canBeRestarted\n            ... on NegativeBlockPermanentlyWhenRewardedRestartIfFailedContentConfigResult {\n              canBeRestarted\n            }\n            ... on NegativeBlockTemporarilyWhenRewardedRestartIfFailedContentConfigResult {\n              blockedUntil\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NodeIcon_NodeFragment on LearnOpportunityV2 {\n  structureDefinition {\n    __typename\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on LearnOpportunityRootExtensionImpl {\n          reducedDataInTree {\n            elementTypes\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ProjectContentButtonCME_LearnOpportunityFragment on LearnOpportunityV2 {\n  id\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      contentNodeAdvancementResult {\n        __typename\n        status\n      }\n    }\n  }\n  ...NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment\n}\n\nfragment UseNodeLogic_NodeFragment on LearnOpportunityV2 {\n  id\n  root {\n    id\n    shortDescription\n  }\n  shortDescription\n  structureDefinition {\n    __typename\n    title\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on LearnOpportunityRootExtensionImpl {\n          internalCode\n          dateTimeOnlyAdminsVisibility\n          isVisibleOnlyForAdmins\n          issuedCertificates {\n            issuedAt\n            fileRef {\n              url\n              id\n            }\n          }\n          reducedDataInTree {\n            cmePoints\n          }\n          firstReleasedAt\n          firstLearnOpportunityIdWithMultipleChoiceElement\n          firstContentNodeIdWithoutMultipleChoiceElement\n          heftContentSubmissionInfo {\n            hasActiveContentSubmission\n          }\n          multipleChoiceContentSubmissionInfo {\n            hasActiveContentSubmission\n          }\n          configConsequences {\n            rewardExpired\n            isRewardedTo\n          }\n        }\n      }\n    }\n  }\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      containedElementTypes\n      contentNodeAdvancementResult {\n        __typename\n        status\n        ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n          status\n          configResults {\n            __typename\n            configType\n            __isRestartIfFailedContentConfigResult: __typename\n            canBeRestarted\n            ... on NegativeBlockPermanentlyWhenRewardedRestartIfFailedContentConfigResult {\n              canBeRestarted\n            }\n            ... on NegativeBlockTemporarilyWhenRewardedRestartIfFailedContentConfigResult {\n              blockedUntil\n            }\n          }\n        }\n      }\n    }\n    ... on LearnOpportunityBranchTypeDefinition {\n      children {\n        id\n        typeDefinition {\n          __typename\n          ... on LearnOpportunityELearningContentTypeDefinition {\n            containedElementTypes\n            contentNodeAdvancementResult {\n              __typename\n              status\n              ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n                status\n                configResults {\n                  __typename\n                  configType\n                  __isRestartIfFailedContentConfigResult: __typename\n                  canBeRestarted\n                  ... on NegativeBlockPermanentlyWhenRewardedRestartIfFailedContentConfigResult {\n                    canBeRestarted\n                  }\n                  ... on NegativeBlockTemporarilyWhenRewardedRestartIfFailedContentConfigResult {\n                    blockedUntil\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ...NodeIcon_NodeFragment\n  ...NodeCardBadgeComponent_Fragment\n  ...NodeCardDateComponent_Fragment\n  ...NodeCardDurationAndAwardComponent_Fragment\n  ...NodeCardFooterContainer_LearnOpportunityFragment\n  ...NodeCardCertificateButton_Fragment\n  ...WissenwirktAttachmentHeftDisplay_LearnOpportunityV2Fragment\n  ...ContentNodesButtons_NodeFragment\n}\n\nfragment WissenwirktAttachmentButtonsDisplayFragment_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  structureDefinition {\n    __typename\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on LearnOpportunityRootExtensionImpl {\n          reducedDataInTree {\n            elementTypes\n          }\n        }\n      }\n    }\n  }\n  root {\n    id\n    attachmentsV2 {\n      __typename\n      title\n      description\n      ... on InfectopharmFileAttachment {\n        file {\n          id\n          url\n          name\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment WissenwirktAttachmentHeftDisplay_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  structureDefinition {\n    __typename\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on LearnOpportunityRootExtensionImpl {\n          firstLearnOpportunityIdWithMultipleChoiceElement\n        }\n      }\n    }\n  }\n  root {\n    id\n    structureDefinition {\n      __typename\n      ... on LearnOpportunityRootStructureDefinition {\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            firstLearnOpportunityIdWithMultipleChoiceElement\n          }\n        }\n      }\n    }\n    attachmentsV2 {\n      __typename\n      ... on InfectopharmFileAttachment {\n        file {\n          url\n          id\n        }\n      }\n      id\n    }\n    typeDefinition {\n      __typename\n      ... on LearnOpportunityBranchTypeDefinition {\n        children {\n          id\n          attachmentsV2 {\n            __typename\n            ... on InfectopharmFileAttachment {\n              file {\n                url\n                id\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n  ...WissenwirktAttachmentButtonsDisplayFragment_LearnOpportunityV2Fragment\n}\n\nfragment searchNodesCarouselComponent_NodeFragment_Kg7Dy on Query {\n  LearnV2 {\n    NodesSearchResult(first: $first, after: $after, query: $query, tagIds: $tagIds, elementTypes: $elementTypes) {\n      pageInfo {\n        endCursor\n        hasPreviousPage\n        hasNextPage\n        startCursor\n      }\n      edges {\n        node {\n          ...UseNodeLogic_NodeFragment\n          id\n          __typename\n        }\n        cursor\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0df53cbaacfd13ab9696f433e3ce814a";

export default node;
